module.exports = __webpack_public_path__ + "img/trolley.e332e5eb.png";